<template>
    <div class="generic-zoom-container" title="Zoom Level">{{ roundedZoomLevel }}</div>
</template>
<style src="./Generic.css" scoped></style>

<style>
.generic-zoom-container {
    width: 2.5rem;
    height: 2.5rem;
    background-color: #063c6d;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    flex-direction: row;
    border-radius: 5.5px;
    border: 2px #063c6d solid;
    color: white;
    font-size: medium !important;
}
</style>

<script>
export default {
    name: 'Generic_ZoomLevel',
    props: [
        'map'
    ],
    computed: {
        roundedZoomLevel() {
            if (this.map) {
                return Math.round(this.map.getView().getZoom())
            } else {
                return undefined
            }
        }
    }
}
</script>
